import { render } from "./AddSupportingDocumentation.vue?vue&type=template&id=7ed00326"
import script from "./AddSupportingDocumentation.vue?vue&type=script&lang=js"
export * from "./AddSupportingDocumentation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__